import React from "react";
import { Link } from "react-router-dom";
import { FiBookOpen, FiArrowLeft, FiCalendar } from "react-icons/fi";

// Friendly empty-state shown when a plan detail endpoint returns 404 (plan
// missing, unpublished, or misconfigured). Full-page glass card with recovery
// actions instead of a bare "Reading plan not found" red bar.

const glassPanel = {
  background:
    "linear-gradient(135deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0.08) 55%, rgba(255,255,255,0.15) 100%)",
  backdropFilter: "blur(22px) saturate(108%)",
  WebkitBackdropFilter: "blur(22px) saturate(108%)",
  border: "1px solid rgba(255,255,255,0.45)",
  boxShadow:
    "0 18px 44px rgba(55,79,99,0.13), inset 0 1px 0 rgba(255,255,255,0.55)",
};

const ReadingPlanUnavailable = ({
  theme = "powder",
  title = "This reading plan isn't available.",
  message = "It may not be published yet, or the link may be wrong. Try one of the options below.",
}) => (
  <div
    data-theme={theme}
    className="min-h-screen bg-page-bg text-on-surface font-inter transition-colors overflow-x-hidden"
  >
    <main className="w-full">
      <div className="w-full max-w-[620px] mx-auto px-margin-mobile py-space-xl flex flex-col gap-space-lg">
        <div
          className="rounded-[1.5rem] p-space-lg md:p-space-xl flex flex-col gap-space-md text-center items-center"
          style={glassPanel}
        >
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center"
            style={{
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.55), rgba(255,255,255,0.35))",
              border: "1px solid rgba(255,255,255,0.45)",
            }}
          >
            <FiBookOpen className="text-accent-cta text-[24px]" aria-hidden="true" />
          </div>

          <div className="flex flex-col gap-space-xs">
            <span className="text-label-sm uppercase tracking-widest text-accent-gold-deep font-bold">
              Reading Plan
            </span>
            <h1 className="font-noto-serif text-headline-lg text-neu-primary">
              {title}
            </h1>
            <p className="text-body-md text-on-surface-variant">{message}</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-space-sm w-full mt-space-xs">
            <Link
              to="/reading-plans"
              className="inline-flex items-center justify-center gap-2 min-h-[48px] w-full rounded-full bg-accent-cta text-white text-label-md font-semibold shadow-[-3px_-3px_7px_var(--outer-shadow-light),4px_5px_10px_rgba(0,0,0,0.22)] hover:bg-accent-cta-hover active:shadow-[inset_2px_2px_5px_rgba(0,0,0,0.3),inset_-2px_-2px_5px_rgba(255,255,255,0.2)] transition-all"
            >
              <FiArrowLeft aria-hidden="true" />
              Reading Plans
            </Link>
            <Link
              to="/devotions/today"
              className="inline-flex items-center justify-center gap-2 min-h-[48px] w-full rounded-full bg-white/60 text-neu-primary text-label-md font-semibold border border-white/60 hover:bg-white/80 active:bg-white/40 transition-all"
            >
              <FiCalendar aria-hidden="true" />
              Today's Devotional
            </Link>
          </div>
        </div>
      </div>
    </main>
  </div>
);

export default ReadingPlanUnavailable;
